"use client";

import { useCookieConsent } from "@/lib/cookie-consent";

export function CookieSettingsButton() {
  const { openSettings } = useCookieConsent();

  return (
    <button
      onClick={openSettings}
      className="hover:text-lime-300 transition-colors cursor-pointer"
    >
      Cookie-Einstellungen
    </button>
  );
}
